import { useTexts } from './useTexts'

export function MultipleValues() {
  const texts = useTexts()

  return texts.multipleValues
}
